import type { HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** registration / crop marks motif */
  crop?: boolean;
  /** built-in padding */
  pad?: boolean;
  children?: ReactNode;
}

export function Card({ crop, pad, className, children, ...rest }: CardProps) {
  const cls = ["card", crop && "crop", pad && "card-pad", className].filter(Boolean).join(" ");
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}
